export default __webpack_public_path__ + "static/home-image2-responsive-42f8288f47107017d8eb5878174d2e54.png";